module.exports = __webpack_public_path__ + "static/media/renjun-6.jpeg";